/**
 * Warstwa API: ROZŚCALENIE ZGŁOSZEŃ — operacja odwrotna do scalenia (2026-09-13).
 *
 * Trasy backendu: `api/tickets/{celId}/rozscalenie/podglad`, `api/tickets/{celId}/rozscal`.
 *
 * ⚠ W OBU trasach identyfikator w ŚCIEŻCE to SPRAWA ZBIORCZA (cel), a identyfikator zgłoszenia
 * wyjmowanego (źródła) jedzie w zapytaniu albo w ciele. To nie jest kosmetyka: dzięki temu obie
 * końcówki przechodzą przez bramkę nagrobka po stronie serwera i odmawiają 409, gdy sama sprawa
 * zbiorcza została w międzyczasie wchłonięta przez jeszcze inną (rozścalać trzeba od góry).
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js (interceptor JWT, cache GET,
 * obsługa 401) i zwraca obiekt nazwanych metod doczepianych do wspólnego `apiService`. Nazwy muszą
 * być unikalne w całej aplikacji — kolizja zatrzymuje start (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /**
         * Co wróci do zgłoszenia źródłowego i czego rozścalenie NIE cofa. Nic nie zapisuje.
         * Odpowiedź z `mozna: false` + `powod` NIE jest błędem — powód jest jej treścią
         * (najczęstszy: scalenie wykonane przed zapisem pochodzenia przeniesionych wierszy).
         */
        getPodgladRozscalenia: (celId, zrodloId) =>
            api.get(`/tickets/${celId}/rozscalenie/podglad`, { params: { zrodloId } }),

        /** Wyjmuje JEDNO wchłonięte zgłoszenie ze sprawy zbiorczej. Wymaga klucza `TicketMerge`. */
        rozscalZgloszenie: (celId, { zrodloId, powod }) =>
            api.post(`/tickets/${celId}/rozscal`, { zrodloId, powod }),
    };
}
